<template>
  <div class="score_wrapper tw-cursor-pointer" @click="clickEvent">
    <div
      :class="excluded ? 'tw-text-[#DBDBDB]' : ''"
      class="tw-flex tw-flex-wrap tw-gap-1 tw-font-medium tw-text-[11px] tw-items-center tw-text-[#878787]"
    >
      {{ firstScore.toFixed(2) }}
      <div class="tw-text-[13px]" :class="excluded ? 'tw-text-[#DBDBDB]' : ''">
        +
      </div>
      <div
        :class="excluded ? 'tw-text-[#DBDBDB]' : ''"
        class="tw-text-[#01893D] tw-font-semibold"
      >
        {{ secondScore.toFixed(2) }}
      </div>
      <div :class="excluded ? 'tw-text-[#DBDBDB]' : ''" class="tw-text-[13px]">
        =
      </div>
      <ScoreIcon :color="excluded ? '#DBDBDB' : '#878787'" />
      {{ Math.round(totalScore * 100) / 100 }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import ScoreIcon from "../svgs/scoreIcon.vue";

const props = defineProps({
  totalScore: {
    type: Number,
    default: 3,
    required: true,
  },
  firstScore: {
    type: Number,
    default: 1.98,
    required: true,
  },
  excluded: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["open-advanced"]);

const secondScore = computed(() => {
  return +props.totalScore.toFixed(2) - +props.firstScore.toFixed(2);
});

const clickEvent = () => {
  emit("open-advanced");
};
</script>

<style scoped lang="scss">
.score_wrapper {
  border: 1px solid #eff0f1;
  width: max-content;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border-radius: 4px;
}
</style>
